import clsx from 'clsx';

const sizeStyles: Record<'small' | 'medium' | 'large', string> = {
  small: 'h-6 w-6 border-2',
  medium: 'h-12 w-12 border-4',
  large: 'h-16 w-16 border-4',
};

type CircleLoadingProps = {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  background?: string;
  className?: string;
};

export default function CircleLoading({
  size = 'medium',
  color = 'border-t-blue-600',
  background = 'border-gray-300',
  className = '',
}: CircleLoadingProps) {
  return (
    <div
      className={clsx([
        'animate-spin rounded-full',
        sizeStyles[size],
        color,
        background,
        className,
      ])}
    />
  );
}
